<template>
    <div class="web-menu" v-if="isDisplay">
        <div class="box" :class="isActive ? 'active' : ''">
            <i class="i-hide pe-7s-close" @click="hideWebMenu()"></i>
            <img src="@/assets/logo.png" alt="ProbPlus Logo" title="ProbPlus Logo" />
            <div class="list">
				<router-link :to="'/' + $route.params.lang" @click.native="hideWebMenu()"><i class="pe-7s-angle-right"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'หน้าหลัก', 'Home') }}</router-link>
				<router-link :to="'/' + $route.params.lang + '/course'" @click.native="hideWebMenu()"><i class="pe-7s-angle-right"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'คอร์สเรียน', 'Course') }}</router-link>
				<router-link :to="'/' + $route.params.lang + '/exam'" @click.native="hideWebMenu()"><i class="pe-7s-angle-right"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'สอบวัดผล', 'Exam') }}</router-link>
                <router-link :to="'/' + $route.params.lang + '/payment'" @click.native="hideWebMenu()"><i class="pe-7s-angle-right"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'การชำระเงิน', 'Payment') }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isActive: false
        }
    },
    props: {
        isDisplay: Boolean
    },
    watch: {
        isDisplay(value) {
            let page = this;

            setTimeout(function () {
                page.isActive = value;
            }, 50);
        }
    },
    methods: {
        hideWebMenu() {
            this.$emit('hideWebMenu');
        }
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.web-menu {
    overflow: hidden;

    .box {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10000;
        border-top: 3px solid $mainColor;
        background: #fff;
        padding: 20px;
        @include transformObject(translateY(-100%));

        &.active {
            @include transformObject(translateY(0));
        }

        .i-hide {
            position: absolute;
            top: 10px;
            right: 10px;
            border: none;
            background: none;
            outline: none;
            font-size: 40px;
            color: $mainColor;
            cursor: pointer;
        }

        img {
            display: block;
            height: 30px;
        }

        .list {
            margin-top: 20px;

            a {
                text-decoration: none;
                display: block;
                font-size: 15px;
                color: #333;
                padding: 10px 0;
                text-align: left;
                outline: none;
                background: none;
                border: none;
                border-bottom: 1px dashed #ddd;

                i {
                    font-size: 22px;
                    margin-right: 5px;
                    @include verticalAlign(sub);
                }

                &:hover {
                    color: $mainColor;
                }
            }
        }
    }
}
</style>